module.exports = __webpack_public_path__ + "static/media/05.7bfb0de1.jpg";